import classNames from 'classnames';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Shown at the left edge; the children stay at the right. */
  left?: ReactNode;
  className?: string;
  spacerSize?: number;
}

export const BottomFixedArea = ({ children, left, className, spacerSize = 3 }: Props) => (
  <>
    <div style={{ marginTop: `${spacerSize}rem` }} />
    <div
      className={classNames(
        'border-l border-l-gray-2 fixed bottom-0 w-full lg:w-[calc(100%-250px)] right-0 z-10',
        className,
      )}
    >
      <div className="h-5 border-b border-b-gray-2 bg-gradient-to-b from-transparent to-[#f6f8fa]" />
      <div className="flex items-center justify-end px-6 py-4 space-x-4 bg-white">
        {left && <div className="mr-auto flex items-center gap-3">{left}</div>}
        {children}
      </div>
    </div>
  </>
);
